import React, { useState } from 'react';

import Tab from '../../components/elements/Tab/Tab';
import AuditLogMerchant from './AutditLogMerchant';
import styles from './styles.scoped.css';

export default function AutditLog() {
  const [tabItem, setTabItem] = useState('pangkalan');
  const tabList = [
    { label: 'Pangkalan', value: 'pangkalan', info: '' },
    { label: 'Sub Pangkalan', value: 'subpangkalan' },
  ];

  const handleChangeTab = (val) => {
    setTabItem(val);
  };

  return(
    <div className={styles.container}>
      <Tab data={tabList} defaultValue={tabItem} onChange={handleChangeTab} />
      <AuditLogMerchant category={tabItem}/>
    </div>
  );
}
